import bannerImage from 'assets/events/banner-2.png';
import { Wrapper } from 'components/base';
import { Link } from 'gatsby';
import PropTypes from 'prop-types';
import React from 'react';
import DisIcon from 'svgs/events/sme/discount.svg';
import CTAButton from '../CTAButton';
import { bannerImageC, content, header, icon, logoC, logoWrapper, navLink, navLinks, navPromote, wrapperC } from './SMEHeader.module.scss';

const SMEHeader = ({ logoUrl }) => (
  <section>
    <header className={header}>
      <Wrapper size="L" className={wrapperC}>
        <div className={logoWrapper}>
          <Link to="/" title="首頁" className={logoC}>
            <img src={logoUrl} alt="newsleopard 電子豹" />
          </Link>
          <ul className={navLinks}>
            <li><a href="#feature" className={navLink}>三大特色</a></li>
            <li><a href="#cases" className={navLink}>使用案例</a></li>
            <li><a href="#pricing" className={navLink}>價格試算</a></li>
            <li><a href="#pricing" className={navPromote}>
              <DisIcon className={icon} />2021/12/31前新會員獨享優惠 (已截止)</a>
            </li>
          </ul>
        </div>
        <div className={content}>
          <CTAButton url="https://app.newsleopard.com/auth/signup?utm_source=SMEcampaignpage&utm_medium=topCTA&utm_campaign=2021newuser" />
        </div>
      </Wrapper>
    </header>
    <a href="#pricing" className={bannerImageC}><img src={bannerImage} /></a>
  </section>
);

SMEHeader.propTypes = {
  logoUrl: PropTypes.string,
}

export default SMEHeader;